(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kernelware-feature-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupComparison = (root = document) => {
      root.querySelectorAll('[data-kw-compare]').forEach((compare) => {
        if (compare.dataset.kwReady === 'true') return;

        const range = compare.querySelector('[data-kw-range]');
        if (!range) return;

        const update = () => {
          compare.style.setProperty('--kw-compare-position', `${range.value}%`);
        };

        range.addEventListener('input', update);
        update();
        compare.dataset.kwReady = 'true';
      });
    };

    const setupProductInfo = (root = document) => {
      root.querySelectorAll('[data-kw-product-info]').forEach((card) => {
        if (card.dataset.kwLoaded === 'true') return;

        const finish = () => {
          card.classList.add('is-loaded');
          card.dataset.kwLoaded = 'true';
        };

        if (document.readyState === 'complete') {
          window.setTimeout(finish, 350);
        } else {
          window.addEventListener('load', () => window.setTimeout(finish, 350), { once: true });
        }
      });
    };

    setupComparison();
    setupProductInfo();

    document.addEventListener('shopify:section:load', (event) => {
      setupComparison(event.target);
      setupProductInfo(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
